import axios from "axios";
import { Toast } from "vant";
const instance = axios.create({
  baseURL: "https://three.weixin.54zkjl.com/weixinn/",
  // baseURL: "http://192.168.88.164:8008/",
  timeout: 5000 * 60,
});

instance.interceptors.response.use(
  (res) => {
    console.log("res", res); // 打印服务器响应的信息
    return res.data; // 返回的这个 res 被 then 方法的 res 形参接收
  },
  (err) => {
    // 打印更详细的错误信息
    if (err.response) {
      // 服务器有响应，但状态码非 2xx
      console.log("响应错误信息：", err.response.data);
      Toast.fail(err.response.data.message);
    } else if (err.request) {
      // 请求已发出，但没有收到响应
      console.log("请求已发出，但没有收到响应", err.request);
    } else {
      // 在设置请求时发生了一些其他错误
      console.log("请求时发生的错误：", err.message);
    }

    // 打印错误配置
    console.log("错误配置：", err.config);

    return Promise.reject(err); // 返回错误对象，继续传递错误
  }
);

export default instance;
